import { CogBoxIcon } from './CogBoxIcon';

/**
 * author: Google
 * id 6F15658D-723C-4BE9-85D1-F170E4B90281
 * name cog-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-box.svg
 * tags
 * - Settings 
 */
export const SettingsApplicationsIcon = CogBoxIcon;
export default SettingsApplicationsIcon